export default __webpack_public_path__ + "static/media/LAS0930.34I-41519_-24868_0.6ce0bf92.jpg";